"use client";

import { c as _c } from "react/compiler-runtime";
import useMasonry from "@/hooks/use-masonry";
import { TStaticContent } from "@/types/types";
import TestimonialCard from "./testimonial-card";
type TestimonialsContainerProps = {
  testimonials: TStaticContent["upworkTestimonials"];
};
export default function TestimonialsContainer(t0) {
  const $ = _c(5);
  const {
    testimonials
  } = t0;
  const masonryContainer = useMasonry();
  let t1;
  if ($[0] !== testimonials) {
    t1 = testimonials.map(_temp);
    $[0] = testimonials;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== masonryContainer || $[3] !== t1) {
    t2 = <div ref={masonryContainer} className="grid items-start gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3">{t1}</div>;
    $[2] = masonryContainer;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

// Recycled

// 28 May 2025

// <Masonry
//   breakpointCols={{ default: 3, 1024: 2, 640: 1 }}
//   className="flex gap-4 bg-green-400"
//   columnClassName="space-y-4"
// >
function _temp(testimonial) {
  return <TestimonialCard key={testimonial.screenshotImageUrl} imageUrl={testimonial.screenshotImageUrl} />;
}